import { z } from "zod";

//
// Read
//

export const DTOElementPropertyValue = z.object({
  id: z.string(),
  designSystemVersionId: z.string(),
  definitionId: z.string(),
  targetElementId: z.string(),
  value: z.union([z.string(), z.number(), z.boolean()]).optional(),
  valuePreview: z.string().optional(),
});

export const DTOElementPropertyValueListResponse = z.object({
  values: z.array(DTOElementPropertyValue),
});

export const DTOElementPropertyValueResponse = z.object({
  value: DTOElementPropertyValue,
});

export const DTOElementPropertyValuesEditActionOutput = z.object({
  type: z.literal("ElementPropertyValuesEdit"),
  output: z.object({ success: z.literal(true) }),
});

export type DTOElementPropertyValue = z.infer<typeof DTOElementPropertyValue>;
export type DTOElementPropertyValueListResponse = z.infer<typeof DTOElementPropertyValueListResponse>;
export type DTOElementPropertyValueResponse = z.infer<typeof DTOElementPropertyValueResponse>;
export type DTOElementPropertyValuesEditActionOutput = z.infer<typeof DTOElementPropertyValuesEditActionOutput>;

//
// Write
//

export const DTOElementPropertyValueUpsertPaylod = z.object({
  definitionId: z.string(),
  targetElementId: z.string(),
  value: z.string().or(z.number()).or(z.boolean()).nullable(),
});

export const DTOElementPropertyValuesEditActionInput = z.object({
  type: z.literal("ElementPropertyValuesEdit"),
  values: DTOElementPropertyValueUpsertPaylod.array(),
});

export type DTOElementPropertyValueUpsertPaylod = z.infer<typeof DTOElementPropertyValueUpsertPaylod>;
export type DTOElementPropertyValuesEditActionInput = z.infer<typeof DTOElementPropertyValuesEditActionInput>;
